import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=57ac05c7&scoped=true&"
import script from "./testimonial.vue?vue&type=script&lang=js&"
export * from "./testimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac05c7",
  null
  
)

export default component.exports